import React, { Fragment, FunctionComponent } from "react";
import BlogPostPageProps from "./BlogPostPageProps.interface";

import ContentPageBlock from "pages/ContentPage/ContentPage.block";

const BlogPostPage: FunctionComponent<BlogPostPageProps> = (props): JSX.Element => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return <ContentPageBlock key={index} {...blockContent} />;
            })}
        </Fragment>
    );
};

export default BlogPostPage;